import { fetchAPI } from "@/utils/fetchAPI";

export type ProductName =
  | "Forfait avec Engagement"
  | "Gestion+ avec Engagement"
  | "Saisie PREMIER"
  | "Gestion+"
  | "eCofiCoffre";

type FetchCofidocRefundsParams = {
  username?: string | null;
  email?: string | null;
  application?: any;
};

export async function fetchCofidocRefunds({ username, email, application }: FetchCofidocRefundsParams = {}) {
  try {
    const queryParams = new URLSearchParams();
    if (username) queryParams.append("username", username);
    if (email) queryParams.append("email", email);

    const queryString = queryParams.toString();
    const url = `/account/refunds${queryString ? `?${queryString}` : ""}`;

    const res = await fetchAPI({
      url,
      options: {
        method: "GET",
      },
      application,
    });

    console.log("res", res);

    return res.map((c) => ({ ...c, date: new Date(c.date_remboursement) }));
  } catch (error) {
    throw new Error();
  }
}
